var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002395",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24.4v16.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002395",
    d: "M0 0h8v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed2939",
    d: "M16 0h8v16h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35.5 18.3 1.3 2h3.7v7.2l-2.8-4.3-3.7 5.9h1.8l1.9-3.4 3.9 7 3.9-7 1.9 3.4h1.8l-3.7-5.9-2.7 4.3v-4h1.6l1.2-1.9h-2.8v-1.2h3.6l1.3-2.1zm4.3 8.8h-4v1.3h4zm7.6 0h-4v1.3h4zm-5.8 7 1.2 3.8-3.2-2.4h4L40.4 38zm-4.5-3.4 1.2 3.8-3.2-2.4h4l-3.2 2.4zm9 0 1.2 3.8-3.2-2.4h4l-3.2 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.3 20.6 1.2 3.8-3.2-2.3h4l-3.2 2.3zm16.6 0 1.2 3.8-3.2-2.3h4l-3.2 2.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTf);
export default __webpack_public_path__ + "static/media/tf.5b419fcbd708f9ce6bd6070b5bd282ac.svg";
export { ForwardRef as ReactComponent };